module.exports = __webpack_public_path__ + "static/img/kz.740ef4bf.svg";